import React, { useState, useEffect } from 'react';
import { listMarketplaceOrders, getOrderDetail } from '../../services/adminMarketplaceService';

const OrderDetailModal = ({ orderId, onClose }) => {
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    getOrderDetail(orderId).then(setDetail);
  }, [orderId]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[85vh] overflow-y-auto p-6 space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-bold">Order detail</h3>
          <button onClick={onClose} className="text-gray-500">Close</button>
        </div>
        {!detail ? <p>Loading...</p> : (
          <>
            <div className="text-sm space-y-1">
              <p><strong>Status:</strong> {detail.order.status}</p>
              <p><strong>Massage type:</strong> {detail.order.massageType}</p>
              <p><strong>Scheduled:</strong> {new Date(detail.order.scheduledDate).toLocaleDateString()} at {detail.order.scheduledTime}</p>
              <p><strong>Client:</strong> {detail.order.clientId?.firstName} {detail.order.clientId?.lastName} ({detail.order.clientId?.email}) — {detail.order.clientId?.status}</p>
              <p><strong>Therapist:</strong> {detail.order.assignedTherapistId ? `${detail.order.assignedTherapistId.firstName} ${detail.order.assignedTherapistId.lastName} (${detail.order.assignedTherapistId.email})` : '—'}</p>
              {detail.order.partnerVenue?.venueId && (
                <p><strong>Venue:</strong> {detail.order.partnerVenue.venueId.businessName} — {detail.order.partnerVenue.venueId.address}</p>
              )}
              {detail.order.clientLocation?.address && (
                <p><strong>Client location:</strong> {detail.order.clientLocation.address}</p>
              )}
              <p><strong>Pricing:</strong> massage ₦{detail.order.pricing.massageFee.toLocaleString()} (therapist ₦{detail.order.pricing.therapistCut.toLocaleString()} / platform ₦{detail.order.pricing.platformCut.toLocaleString()}){detail.order.pricing.venueFee > 0 && `, venue ₦${detail.order.pricing.venueFee.toLocaleString()} (venue ₦${detail.order.pricing.venueCut.toLocaleString()} / platform ₦${detail.order.pricing.venuePlatformCut.toLocaleString()})`}</p>
              {detail.order.session?.startedAt && <p><strong>Session:</strong> started {new Date(detail.order.session.startedAt).toLocaleString()}{detail.order.session.endedAt && `, ended ${new Date(detail.order.session.endedAt).toLocaleString()}`}</p>}
              {detail.order.cancellation?.cancelledAt && (
                <p><strong>Cancelled:</strong> by {detail.order.cancellation.cancelledBy} — {detail.order.cancellation.reason} (refund: {detail.order.cancellation.refundTier})</p>
              )}
            </div>

            {detail.transaction && (
              <div className="border-t pt-3">
                <p className="font-semibold text-sm mb-1">Escrow ledger — {detail.transaction.escrowStatus}</p>
                <ul className="text-sm space-y-1">
                  {detail.transaction.legs.map((leg, i) => (
                    <li key={i}>{leg.type}: ₦{leg.amount.toLocaleString()} — {leg.payoutStatus}{leg.failureReason && ` (${leg.failureReason})`}</li>
                  ))}
                </ul>
              </div>
            )}

            {detail.ratings?.length > 0 && (
              <div className="border-t pt-3">
                <p className="font-semibold text-sm mb-1">Ratings</p>
                <ul className="text-sm space-y-1">
                  {detail.ratings.map(r => (
                    <li key={r._id}>{r.raterRole} rated: {r.score}★{r.comment && ` — "${r.comment}"`}{r.flaggedAsThreat && ' ⚠️ flagged as threat'}</li>
                  ))}
                </ul>
              </div>
            )}

            {detail.dispute && (
              <div className="border-t pt-3">
                <p className="font-semibold text-sm mb-1">Dispute — {detail.dispute.status}</p>
                <p className="text-sm">{detail.dispute.reason}: {detail.dispute.description}</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const MarketplaceOrders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    listMarketplaceOrders().then(setOrders);
  }, []);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Marketplace orders</h2>
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b">
              <th className="p-3">Client</th>
              <th className="p-3">Therapist</th>
              <th className="p-3">Type</th>
              <th className="p-3">Status</th>
              <th className="p-3">Amount</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o._id} className="border-b hover:bg-gray-50 cursor-pointer" onClick={() => setSelectedId(o._id)}>
                <td className="p-3">{o.clientId?.email}</td>
                <td className="p-3">{o.assignedTherapistId?.email || '—'}</td>
                <td className="p-3">{o.massageType}</td>
                <td className="p-3">{o.status}</td>
                <td className="p-3">₦{o.pricing.totalAmount.toLocaleString()}</td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td className="p-3 text-gray-500" colSpan={5}>No orders yet.</td></tr>}
          </tbody>
        </table>
      </div>
      {selectedId && <OrderDetailModal orderId={selectedId} onClose={() => setSelectedId(null)} />}
    </div>
  );
};

export default MarketplaceOrders;
